export default {
  selectedPeriod: '',
  __typename: 'SubscriptionsExtend'
};
